import React, { useContext, useEffect, useState, useMemo } from 'react';
import { ButtonType, ContainedButton } from 'atoms/Buttons';
import { ReactSVG } from 'react-svg';
import { CheckoutDetailsClick } from 'common/utilities/analyticsUtils';
import OffersCoupon from 'organisms/CartPage/AU/Presentation/ReusableComponents/OffersCoupon';
import GiftCardVouchers from 'organisms/CartPage/AU/Presentation/ReusableComponents/GiftCardVouchers';
import { CART_PAGE_CONSTANTS } from 'organisms/CartPage/Constants/CartPageConstants';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import { IMAGE_PATH } from 'common/ImageConstants/ImagePathUtils';
import {
  getTernaryValue,
  isEmptyEvery,
  ParseJsonSafely,  
  throttle,
  isCateringDisposition,
  checkIfStoreShutDown,
  redirectToCARTPage,
  isStoreTemproryClosed,
  isAsapOrder,
  toastifyFn,
  getAndCheckIfOneTrue,
  validateFlagAndCallFunc
} from 'common/utilities/utils';
import { checkCategoryAvailability } from 'molecules/DynamicMenuAlert/AU/Utils/DynamicMenuAlertUtils';
import { UserOrderContext } from 'context/context';
import { TRANSLATE_MAPPING_KEY } from 'common/constants/i18nTranslateKeys';
import { LOCAL_STORAGE_KEYS, ASAP, OPEN, APPLY_FREE_DELIVERY } from 'common/constants/SharedConstants';
import { getAllTaxDetails, getBottleDepositCharge } from 'common/sharedTemplates/sharedTemplates';
import { maxOrderLimitForStore, cartSummaryErrorMessage, cartCheckOutHandler, setCheckoutButtonDisabledErr } from 'organisms/CartPage/AU/Utils/cartPageUtils';
import ImageComponent from 'atoms/Image';
import CONSTANTS from 'organisms/ContactUs/Constants';
import CartAlertForm from 'molecules/Alert/Presentation/Alert/AlertForm';
import CartAlertFormInsideModel from 'molecules/Alert/Container/AlertFormInsideModel';
import { useSelector, useDispatch } from 'react-redux';
import START_ORDER_CONSTANTS from 'organisms/StartOrderComponent/Constants/startOrderConstants';
import { setChangeOrderAnalyticsData } from 'organisms/StartOrderComponent/StartOrderUtilities/startOderUtils';
import { checkForScheduledTime } from 'organisms/ScheduleOrder/ScheduleOrderUtils/ScheduleOrderUtils';
import isEmpty from 'lodash/isEmpty';
import { orderReadyDateTimeUpdate } from '@kfc-global/react-shared/redux/Actions/StoresAction';
import { removeCouponAction } from '@kfc-global/react-shared/redux/Actions/CartAction';
import RemoveGiftCardModal from 'organisms/CartPage/AU/Presentation/ReusableComponents/RemoveGiftCardModal';
import { getCustomerInfo } from '@kfc-global/react-shared/redux/Actions/OrderservAction';
import { useWiCodeFinaliseStatus } from 'customHooks';

export const getAlertModalTitle = (enableClickCollectScheduleOrderFlag, isStoreTemproryClosedFlag, scheduleTimeCheck) =>
  enableClickCollectScheduleOrderFlag && isStoreTemproryClosedFlag && !scheduleTimeCheck
    ? translateWithI18Next(TRANSLATE_MAPPING_KEY.STORE_NOT_SERVING_CURRENTLY)
    : translateWithI18Next(TRANSLATE_MAPPING_KEY.ORDER_TIME_PASSED_TITLE);
/**
 * Method to open open date time module
 */
export const onRescheduleOrderHandler = (event, setOrderScheduleModal, userOrderStateDispatch, storeInfo) => {
  const {
    SCHEDULE_ORDER_DATA,
    SEARCH_ORDER_DATA,
    CURRENT_STORE_INFO,
    SET_FIND_A_KFC_VIEW,
    SHOW_SCHEDULE_DISPOSITION,
    CHANGE_SCHEDULE_MODE,
    SCHEDULE_ORDER_CLICKED,
    SET_ORDER_NOW,
    SET_SCHEDULE_ORDER,
  } = START_ORDER_CONSTANTS;
  event?.preventDefault();
  event?.stopPropagation();
  setOrderScheduleModal(false);
  userOrderStateDispatch({ type: SET_FIND_A_KFC_VIEW, value: { findAKFC: false } });
  userOrderStateDispatch({ type: SEARCH_ORDER_DATA, value: { showSearchStore: false } });
  userOrderStateDispatch({
    type: SCHEDULE_ORDER_DATA,
    value: { showScheduleOrderCatering: true, selectedStoreInfo: storeInfo },
  });
  setChangeOrderAnalyticsData();
  userOrderStateDispatch({
    type: CHANGE_SCHEDULE_MODE,
    value: { changeScheduleModeFlag: false },
  });
  userOrderStateDispatch({
    type: SCHEDULE_ORDER_CLICKED,
    value: { scheduleModeClicked: true },
  });
  userOrderStateDispatch({
    type: SET_ORDER_NOW,
    value: { showOrderNow: false },
  });
  userOrderStateDispatch({
    type: SET_SCHEDULE_ORDER,
    value: { showScheduleOrder: true },
  });
  userOrderStateDispatch({
    type: SHOW_SCHEDULE_DISPOSITION,
    value: { showSheduleDisposition: true },
  });
  userOrderStateDispatch({
    type: CURRENT_STORE_INFO,
    value: storeInfo,
  });
};
const getValidPromos = (discountAmounts, APPLIED) => {
  return discountAmounts?.filter?.(item => item?.status === APPLIED && +item?.amount > 0);
};
const checkMetCondition = (discountAmounts, ifAnyInValidPromo, loggedIn, enableAddGiftCardOrVoucher, showPromoRewardsMessage) => {
  return discountAmounts?.length > 0 ?   
   ((enableAddGiftCardOrVoucher && !showPromoRewardsMessage && ifAnyInValidPromo ) || (showPromoRewardsMessage && (ifAnyInValidPromo || !loggedIn))) 
  : false
};

const isInViewport = element => {
  const rect = element.getBoundingClientRect();
  return (
    (rect.top >= 0 && rect.bottom <= window.innerHeight) ||
    (rect.top < 0 && rect.bottom < 0) ||
    (rect.top <= 0 && rect.bottom > 0)
  );
};

const getDispositionNew = userOrderState => {
  return isEmpty(userOrderState?.dispositionNew) || userOrderState?.dispositionNew?.type === ''
    ? JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.DISPOSITION_NEW))
    : userOrderState?.dispositionNew;
};

export const showIsAsapFlag = (storeStatus, orderASAP, storesWithStatus) => storeStatus === OPEN && isAsapOrder(storesWithStatus[0]) ? orderASAP : '';

const promosUnMetMessage = params => {
  if (params?.unMetConditionFound) {
    return (
      <div className='promos-summary-cart-notification'>
        <div className='notify-alert'>
          <ReactSVG src={params?.Error_Yellow} alt='Error_Yellow' className='location-alert-icon' />
          <span>{translateWithI18Next(params?.PROMO_UNMET_SUMMARY_MESSAGE)}</span>
        </div>
      </div>
    );
  }
};
const checkoutUnavailableErrorMessage = params => {
  if (checkIfStoreShutDown(params?.storesWithStatus)) {
    return (
      <div className='store-unavailable-notification'>
        <div className='notify-alert'>
          <div>
            <ImageComponent srcFile={params?.Ellipse} className='location-alert-icon' />
          </div>
          <span>{translateWithI18Next(params?.CHECKOUT_UNAVAILABLE_AT_STORE)}</span>
        </div>
      </div>
    );
  }
};

const getPromiseTime = storesWithStatus => {
  return storesWithStatus && storesWithStatus[0]?.summary?.timings?.asap?.promiseTime;
};
export const maxVoucherLimitExceededMessage = (params) => {
    return (
      <div className='voucher-summary-cart-notification-limit-exceeded'>
        <div className='notify-alert-wicode'>
          <ReactSVG src={params?.Ellipse} alt='Error_Red' className='location-alert-icon' />
          <span>{translateWithI18Next(params?.MAX_VOUCHER_LIMIT_EXCEEDED)}</span>
        </div>
      </div>
    );
};
export const wicodeAutoReleasedReapplyMessage = (params) => {
  return (
    <div className='voucher-summary-cart-notification-voucher-above-subtotal voucher-summary-cart-notification-wicode-auto-released'>
      <div className='notify-alert-wicode'>
        <ReactSVG src={params?.Ellipse_Orange} alt='Warning_Red' className='location-alert-icon' />
        <span>{translateWithI18Next(params?.WICODE_AUTO_RELEASED)}</span>
      </div>
    </div>
  );
};
export const mealFullyCoveredByDiscountMessage = params => {
  const remainingBalance = params?.checkIfMealFullyCoveredAmt?.remainingBalance;
  const type = params?.checkIfMealFullyCoveredAmt?.type;
  const isVoucher = type === params?.VOUCHER;
  const isGiftCard = type === params?.GIFTCARD;
  const isVoucheAboveSubTotal = isVoucher && remainingBalance > 0;
  const isGiftCardAboveSubTotal = isGiftCard && remainingBalance > 0;
  const imageSrc = isVoucheAboveSubTotal ? params?.Ellipse_Orange : params?.GreenCheck;
  const giftCardMessage = isGiftCardAboveSubTotal
    ? params?.GIFT_CARD_ABOVE_SUBTOTAL
    : params?.GIFT_CARD_MEAL_FULLY_COVERED;
  const voucherMessage = isVoucheAboveSubTotal ? params?.VOUCHER_ABOVE_SUBTOTAL : params?.VOUCHER_MEAL_FULLY_COVERED;
  const warningMessage = isVoucher ? voucherMessage : giftCardMessage;
  return (
    <div
      className={
        isVoucheAboveSubTotal
          ? 'voucher-summary-cart-notification-voucher-above-subtotal'
          : 'voucher-summary-cart-notification-meal-fully-covered'
      }
    >
      <div className='notify-alert-wicode'>
        <ReactSVG
          src={imageSrc}
          alt={isVoucheAboveSubTotal ? 'Warning_Red' : 'Warning_Green'}
          className='location-alert-icon'
        />
        <span>{translateWithI18Next(warningMessage)}</span>
      </div>
    </div>
  );
};
export const WiCodediscountedItems = (params) => {
  const { isAppliedFreeDelivery, validPaymentDiscount, minusSign, currencySymbol, couponModalHandler,GIFTCARD, GIFT_CARD, CircleCloseButton} = params;
  return validPaymentDiscount
    ?.filter(promo =>
      getTernaryValue(
        isAppliedFreeDelivery,
        promo?.promoAction?.actionName === APPLY_FREE_DELIVERY,
        promo?.promoAction?.actionName !== APPLY_FREE_DELIVERY,
      ),
    )
    .map((item, index) => {
      const titleValue = item?.title === GIFTCARD ? GIFT_CARD : item?.title;
      return (
        <div className='cart-summary-content-item'>
          <div className='cart-summary-content-item-name-wicode'>
            <span className='cart-discount-code'>
              {titleValue + ' '} ({item.couponCode})
            </span>
            <span
              className='cart-discount-clear-icon'
              data-testid={`remove-coupon-handler-${item?.couponCode}`}
              onClick={() => couponModalHandler(item)}
            >
              <img src={CircleCloseButton} alt = 'CircleCloseButton'/>
            </span>

          </div>
          <div className='cart-summary-content-item-value checkout-summary-content-item-value'>
            {minusSign}
            {currencySymbol}
            {item?.amount}
          </div>
        </div>
      );
    });
};
export const checkIfMealFullyCovered = (subTotal, paymentDiscountAmounts, paymentDiscountTotal) => {
  const { APPLIED_COUPON } = CART_PAGE_CONSTANTS;
  if (subTotal - paymentDiscountTotal === 0) {
    const appliedPaymentDiscountAmount =
      paymentDiscountAmounts[paymentDiscountAmounts?.length - 1]?.status === APPLIED_COUPON;
    const remainingBalance =
      appliedPaymentDiscountAmount && paymentDiscountAmounts[paymentDiscountAmounts?.length - 1]?.remainingBalance;
    const type = appliedPaymentDiscountAmount && paymentDiscountAmounts[paymentDiscountAmounts?.length - 1]?.title;
    return { type, remainingBalance: Number(remainingBalance) };
  }
  return false;
};
export const showWicodeErrorMessage = ({isValidPaymentDiscount,validPaymentDiscount,minusSign,currencySymbol,couponModalHandler, GIFTCARD, GIFT_CARD, Ellipse_Orange, WICODE_AUTO_RELEASED, history, CircleCloseButton }) => {
  if (isValidPaymentDiscount) {
    return (
      <>
        {WiCodediscountedItems({
          isAppliedFreeDelivery: false,
          validPaymentDiscount,
          minusSign,
          currencySymbol,
          couponModalHandler,
          GIFTCARD,
          GIFT_CARD,
          CircleCloseButton
        })}
        <hr />
      </>
    );
  } else {
    return history?.location?.isWicodeFinaliseFailed && wicodeAutoReleasedReapplyMessage({ Ellipse_Orange, WICODE_AUTO_RELEASED });
  }
};
export const isPromoValid = (enableAddGiftCardOrVoucher, validPromos, unMetConditionFound) =>
  enableAddGiftCardOrVoucher ? validPromos?.length > 0 : Boolean(validPromos?.length > 0 && !unMetConditionFound);

export const showPromoBanner = (showPromoRewardsMessage, isValidPrmos) => showPromoRewardsMessage && isValidPrmos;

export const promoBannerSection = (showPromoRewardsMessage, isValidPrmos, bucketId, validPromos) =>
  showPromoBanner(showPromoRewardsMessage, isValidPrmos) && (
    <OffersCoupon bucketId={bucketId} discountAmounts={validPromos} />
  );
const CartSummaryCard = props => {
  const {
    contentData = {},
    currencySymbol = '',
    currencyConversionFactor = '',
    bucketId = '',
    isMobile,
    confirmChangesHandler,
    isModelClosed,
    loggedIn,
    dispositionData,
    storesWithStatus,
    cartList,
    showTaxLines,
    history
  } = props;
  const {
    totalAmount = '',
    quantity = '',
    subTotal = '',
    additionalCharges,
    taxLines,
    bottleDepositChargeTotal = 0,
    discountAmounts = [],
    paymentDiscountAmounts = [],
    paymentDiscountTotal
  } = contentData;
  const { CART_SUMMARY_CARD, FROMCHECKOUT, APPLIED, APPLIED_COUPON, VOUCHER, GIFT_CARD, GIFTCARD, REMOVE_COUPON} = CART_PAGE_CONSTANTS;
  const {
    GST_INCLUDED,
    PROMO_UNMET_SUMMARY_MESSAGE,
    CHECKOUT_UNAVAILABLE_AT_STORE,
    ORDER_TIME_PASSED_MSG,
    RESCHEDULE_ORDER_TIME_BUTTON,
    ORDER_ASAP,
    REMOVE_GIFT_CARD,
    REMOVE_VOUCHER,
    GIFT_CARD_ERROR_FIRST_MSG,
    GIFT_CARD_ERROR_SECOND_MSG,
    VOUCHER_ERROR_SECOND_MSG,
    GIFT_CARD_TOAST,
    VOUCHER_TOAST,
    REMOVE,
  } = TRANSLATE_MAPPING_KEY;
  const { QUANTITY_TEXT, QUANTITYS_TEXT, SUBTOTAL, CHECKOUT } = CART_SUMMARY_CARD;
  const { Error_Yellow, CartError, Ellipse, Timeout_Red, GreenCheck, Ellipse_Orange, CircleCloseButton} = IMAGE_PATH;
  const { CART_CATERING_ALERT_STARTTEXT, CART_CATERING_ALERT_ENDTEXT, CART_CATERING_CONTENT_TEXT,GIFT_CARD_MEAL_FULLY_COVERED, GIFT_CARD_ABOVE_SUBTOTAL,VOUCHER_MEAL_FULLY_COVERED, VOUCHER_ABOVE_SUBTOTAL, WICODE_AUTO_RELEASED} = TRANSLATE_MAPPING_KEY;
  const { userOrderState, userOrderStateDispatch } = useContext(UserOrderContext);
  const [OrderScheduleModal, setOrderScheduleModal] = useState(false);
  const [checkoutButton, setCheckoutButton] = useState(false);
  const [checkoutButtonDisabled, setCheckoutButtonDisabled] = useState(false);
  const [showCateringAlert, setShowCateringAlert] = useState(false);
  const [couponModal, setCouponModal] = useState(false);
  const [couponCode, setCouponCode] = useState(false);
  const [couponTitle, setCouponTitle] = useState(false);

  const storeInfo = useMemo(() => {
    return isEmptyEvery(userOrderState.currentStoreInfo)
      ? ParseJsonSafely(localStorage.getItem(LOCAL_STORAGE_KEYS.CURRENT_STORE_INFO_STORAGE))
      : userOrderState.currentStoreInfo;
  }, [userOrderState.currentStoreInfo]);
  const { timeBasedCetegory, timeBasedAlertModalData } = userOrderState;
  const { maxOrderAmount = 0, minOrderAmount = 0 } =
    storeInfo?.summary?.menu ?? ParseJsonSafely(localStorage.getItem(LOCAL_STORAGE_KEYS.PRICE_LIMITS)) ?? {};
  const { overLimitFlag, betweenLimitFlag } = maxOrderLimitForStore(
    totalAmount,
    maxOrderAmount,
    minOrderAmount,
    currencyConversionFactor,
  );

  useEffect(() => {
    if (
      timeBasedAlertModalData?.title === START_ORDER_CONSTANTS?.REVIEW_ORDER_MODAL &&
      !timeBasedAlertModalData?.isReviewOrderClick
    ) {
      setCheckoutButtonDisabled(false);
    }
  }, [timeBasedAlertModalData]);
  const tenantReducer = useSelector(data => data.tenantReducer);
  const { componentOptions } = tenantReducer;
  let userParams = useSelector(data => data.appStateReducer.userStatus);
  const authReducer = useSelector(data => data.authReducer);
  const { enableAddGiftCardOrVoucher = false, showPromoRewardsMessage = false } = componentOptions?.web?.cartPage || {};
  const minusSign = '-';
  const validPromos = getValidPromos(discountAmounts, APPLIED);
  const validPaymentDiscount = getValidPromos(paymentDiscountAmounts, APPLIED_COUPON);
  const ifAnyInValidPaymentDiscount = paymentDiscountAmounts?.some?.(item => item?.isError);
  const ifAnyInValidPromo = discountAmounts?.some?.(item => item?.isError);
  const unMetConditionFound = checkMetCondition(discountAmounts, ifAnyInValidPromo, loggedIn,enableAddGiftCardOrVoucher,showPromoRewardsMessage);
  const unMetPaymentDiscountConditionFound = checkMetCondition(
    paymentDiscountAmounts,
    ifAnyInValidPaymentDiscount,
    loggedIn,
    enableAddGiftCardOrVoucher,
    showPromoRewardsMessage
  );
  const isValidPaymentDiscount = Boolean(validPaymentDiscount?.length > 0 && !unMetPaymentDiscountConditionFound);
  const isValidPrmos = isPromoValid(enableAddGiftCardOrVoucher, validPromos, unMetConditionFound);
  const storeSummary = storesWithStatus && storesWithStatus[0]?.summary;
  const storeTimeZone = storesWithStatus && storesWithStatus[0]?.summary?.timeZoneIANA;
  const storeStatus = storesWithStatus && storesWithStatus[0]?.summary?.status?.currentStatus;
  const promiseTime = getPromiseTime(storesWithStatus);
  const checkIfMealFullyCoveredAmt = checkIfMealFullyCovered (subTotal, paymentDiscountAmounts, paymentDiscountTotal);
  const isMealFullyCovered = Boolean(checkIfMealFullyCoveredAmt?.remainingBalance >= 0);
  const {
    SET_ASAP_SCHEDULING
  } = START_ORDER_CONSTANTS;
  const dispositionNew = getDispositionNew(userOrderState);
  const cartReducer = useSelector(data => data.cartReducer);
  const { enableScheduleOrder, enableClickCollectScheduleOrder } = componentOptions?.web?.dispositionConfig || {};
  const allowScheduleOrderForDispositions = componentOptions?.web?.scheduledDelivery?.allowScheduleOrderForDispositions;
  const enableClickCollectScheduleOrderFlag =
    enableClickCollectScheduleOrder && allowScheduleOrderForDispositions.includes(storeInfo?.service);

  // enableScheduleOrder and enableClickCollectScheduleOrderFlag flags are only for CA and SA tenants.
  const enableScheduleOrderFlag = getAndCheckIfOneTrue(enableScheduleOrder,enableClickCollectScheduleOrderFlag); 
  const isStoreTemproryClosedFlag = validateFlagAndCallFunc(enableScheduleOrderFlag,isStoreTemproryClosed,[cartReducer?.cartData, storeSummary]);

  const scheduleTimeCheck = checkForScheduledTime({
    enableScheduleOrder,
    enableClickCollectScheduleOrder,
    timeZone: storeTimeZone,
    storeSelectedDate: dispositionNew?.date,
    storeSelectedTime: dispositionNew?.time,
    promiseTime,
  });
  const dispatch = useDispatch();
  const orderASAP = () => {
    setOrderScheduleModal(false);
    userOrderStateDispatch({
      type: START_ORDER_CONSTANTS?.SET_DISPOSITION_NEW,
      value: { dispositionNew: { ...dispositionData, date: ASAP, selectedTime: ASAP, time: ASAP } },
    });
    userOrderStateDispatch({
      type: START_ORDER_CONSTANTS.SET_ORDER_NOW,
      value: { showOrderNow: true },
    });
    userOrderStateDispatch({
      type: START_ORDER_CONSTANTS.SET_SCHEDULE_ORDER,
      value: { showScheduleOrder: false },
    });
    userOrderStateDispatch({ type: SET_ASAP_SCHEDULING, value: { enableASAPScheduling: true } });
    localStorage.setItem(
      LOCAL_STORAGE_KEYS.DISPOSITION_NEW,
      JSON.stringify({ ...dispositionData, date: '', selectedTime: ASAP, time: ASAP }),
    );
    localStorage.setItem(
      LOCAL_STORAGE_KEYS.DATE_TIME_ORDER,
      JSON.stringify({ date: '', SelectedTime: ASAP, time: ASAP }),
    );
    const postBody = {
      isForNow: true,
      futureDateTime: 0,
    };
    dispatch(
      orderReadyDateTimeUpdate({
        params: { basketId: cartReducer?.cartData?.id },
        tenantId: tenantReducer?.tenantId,
        postBody: postBody,
      }),
    );
    redirectToCARTPage(props);
  };
  const isVoucher = couponTitle === VOUCHER;
  useWiCodeFinaliseStatus(userParams, authReducer, history, dispatch, getCustomerInfo);
  const modalCloseHandler = () => {
    setOrderScheduleModal(false);
    setCheckoutButtonDisabled(true);
  };

  const navigateToCheckout = event => {
    event?.stopPropagation();
    event?.preventDefault();

    if (timeBasedCetegory?.timebasedItemInCart && timeBasedCetegory?.isTimeExpired) {
      setCheckoutButtonDisabled(true);
      const checkItemExpAlert = checkCategoryAvailability(
        {
          categoryUrl: timeBasedCetegory?.url,
          alertType: START_ORDER_CONSTANTS?.CART_REVIEW_ORDER_MODAL,
          itemInCart: true,
        },
        timeBasedCetegory,
        userOrderStateDispatch,
      );
      if (checkItemExpAlert) {
        return;
      }
    }

    cartCheckOutHandler({
      storesWithStatus,
      dispositionData,
      confirmChangesHandler,
      CheckoutDetailsClick,
      setShowCateringAlert,
      setCheckoutButtonDisabled,
      FROMCHECKOUT,
      scheduleTimeCheck,
      setOrderScheduleModal,
    });
  };
  const removeCouponHandler = (code, title) => {
    const isVoucherFlag = title === VOUCHER;
    dispatch(
      removeCouponAction({
        basketId: bucketId,
        tenantId: tenantReducer?.tenantId,
        couponCode: code,
      },()=>{
        isVoucherFlag ? toastifyFn(translateWithI18Next(VOUCHER_TOAST)) : toastifyFn(translateWithI18Next(GIFT_CARD_TOAST))
        setCouponModal(false);
      }),
    );  
  };
  const handleClose = () => {
    setShowCateringAlert(false);
    setCheckoutButtonDisabled(true);
  }

  const checkIsInViewport = () => {
    const element = document.getElementById('summary-card');
    const summaryCart = isInViewport(element);
    setCheckoutButton(summaryCart);
  };

  const couponModalHandler = (item) => {
    setCouponModal(true);
    setCouponCode(item?.couponCode);
    setCouponTitle(item?.title);
  }

  const onScroll = throttle(checkIsInViewport, 500);
  useEffect(() => {
    /* show alert popup on page load */
    if (timeBasedCetegory?.timebasedItemInCart && timeBasedCetegory?.isTimeExpired) {
      setCheckoutButtonDisabled(true);
    } else {
      setCheckoutButtonDisabled(false);
    }
    if (isMobile) {
      document.addEventListener('scroll', onScroll);
    }
    return () => {
      document.removeEventListener('scroll', onScroll);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isMobile, timeBasedCetegory]);

  const titleTemplate = (
    <>
      {translateWithI18Next(CART_CATERING_ALERT_STARTTEXT)}
      <br></br>
      {translateWithI18Next(CART_CATERING_ALERT_ENDTEXT)}
    </>
  );

  const discountedItems = (isAppliedFreeDelivery = false) => {
    return validPromos?.filter(promo => getTernaryValue(isAppliedFreeDelivery, promo?.promoAction?.actionName === 'ApplyFreeDelivery' , promo?.promoAction?.actionName !== 'ApplyFreeDelivery')).map((item, index) => {
      const titleValue = item?.title;
      return (
        <div className='cart-summary-content-item'>
          <div className='cart-summary-content-item-name checkout-summary-content-item-value'>{titleValue}</div>
          <div className='cart-summary-content-item-value checkout-summary-content-item-value'>
            {minusSign}
            {currencySymbol}
            {item?.amount}
          </div>
        </div>
      );
    });
  };



  const isBasketDetailsLoading = useSelector(
    data =>
      data.cartReducer?.isBasketDetailsLoading ||
      data.cartReducer?.isUpdateQuantityLoading ||
      data.cartReducer?.isValidateBasketLoading ||
      data.storesReducer?.isStoreStatusLoading ||
      data.orderReducer?.isCreateOrderLoading ||
      data.orderReducer?.isPlaceOrder,
  );
  return (
    <div className='cart-summary-card-container' id='summary-card' data-testid='cart-summary-card-global'>
      <h2 className='cart-summary-item-count'>
        {quantity}{' '}
        {getTernaryValue(quantity === 1, translateWithI18Next(QUANTITY_TEXT), translateWithI18Next(QUANTITYS_TEXT))}
      </h2>
      <div className='cart-summary-coupons'>
        {promoBannerSection(showPromoRewardsMessage, isValidPrmos, bucketId, validPromos)}
        {enableAddGiftCardOrVoucher && (
          <GiftCardVouchers
            bucketId={bucketId}
            showPromoRewardsMessage={showPromoRewardsMessage}
            isMealFullyCovered={isMealFullyCovered}
          />
        )}
      </div>
      <div className='cart-summary-content' data-testid='cart-summary-content'>
        {!showPromoRewardsMessage &&
          enableAddGiftCardOrVoucher &&
          showWicodeErrorMessage({
            isValidPaymentDiscount,
            validPaymentDiscount,
            minusSign,
            currencySymbol,
            couponModalHandler,
            GIFTCARD,
            GIFT_CARD,
            Ellipse_Orange,
            WICODE_AUTO_RELEASED,
            history,
            CircleCloseButton,
          })}
        <div className='cart-summary-content-item'>
          <div className='cart-summary-content-item-name'>{translateWithI18Next(SUBTOTAL)}</div>
          <div className='cart-summary-content-item-value checkout-summary-content-item-value'>
            {currencySymbol}
            {subTotal}
          </div>
        </div>
        {showTaxLines && taxLines.length > 0 ? (
          getAllTaxDetails(
            taxLines,
            currencySymbol,
            currencyConversionFactor,
            CART_PAGE_CONSTANTS.CART_SUMMARY_CARD.CART,
          )
        ) : (
          <div className='cart-summary-details'>
            <div className='cart-summary-gst'>{translateWithI18Next(GST_INCLUDED)}</div>
          </div>
        )}
        {Boolean((showPromoRewardsMessage && isValidPrmos) || additionalCharges?.length > 0) && <hr />}
        {showPromoRewardsMessage && isValidPrmos && discountedItems()}
        {additionalCharges?.length > 0 && (
          <div className='cart-summary-content-item'>
            <div className='cart-summary-content-item-name'>
              {translateWithI18Next(TRANSLATE_MAPPING_KEY?.DELIVERY_FEE)}
            </div>
            <div className='cart-summary-content-item-value checkout-summary-content-item-value'>
              {currencySymbol}
              {additionalCharges[0]?.amount}
            </div>
          </div>
        )}
        <hr />
        {getBottleDepositCharge(
          bottleDepositChargeTotal,
          currencySymbol,
          currencyConversionFactor,
          CART_SUMMARY_CARD?.CART,
        )}
        {!showPromoRewardsMessage && enableAddGiftCardOrVoucher && isValidPaymentDiscount && isMealFullyCovered &&
              mealFullyCoveredByDiscountMessage({
                GreenCheck,
                Ellipse_Orange,
                checkIfMealFullyCoveredAmt,
                GIFT_CARD_MEAL_FULLY_COVERED,
                GIFT_CARD_ABOVE_SUBTOTAL,
                VOUCHER_MEAL_FULLY_COVERED,
                VOUCHER_ABOVE_SUBTOTAL,
                VOUCHER,
                GIFT_CARD,
                GIFTCARD,
              })}
      </div>
      <div
        className={`cart-summary-checkout-button-container cart-summary-checkout-button-mobile ${
          checkoutButtonDisabled && 'checkout-unavailable'
        }`}
      >
        <ContainedButton
          className='cart-summary-checkout-button'
          variant={ButtonType.primary}
          fullWidth
          hasPrices
          loading={isBasketDetailsLoading}
          inactive={setCheckoutButtonDisabledErr({
            isBasketDetailsLoading,
            showPromoRewardsMessage,
            overLimitFlag,
            betweenLimitFlag,
            isModelClosed,
            unMetConditionFound,
            checkoutButtonDisabled,
            timeBasedCetegory,
            cartList,
            storesWithStatus,
            enableAddGiftCardOrVoucher,
            unMetPaymentDiscountConditionFound,
            isValidPaymentDiscount,
          })}
          data-testid='navigation-checkout-desktop'
          onClick={navigateToCheckout}
        >
          <span>{translateWithI18Next(CHECKOUT)}</span>
          <span>
            {currencySymbol}
            {totalAmount}
          </span>
        </ContainedButton>

        {promosUnMetMessage({ unMetConditionFound, Error_Yellow, PROMO_UNMET_SUMMARY_MESSAGE })}
        {checkoutUnavailableErrorMessage({ storesWithStatus, Ellipse, CHECKOUT_UNAVAILABLE_AT_STORE })}
      </div>
      {couponModal && (
        <RemoveGiftCardModal
          removeCouponHandler={removeCouponHandler}
          couponCode={couponCode}
          couponTitle={couponTitle}
          flag={REMOVE_COUPON}
          setCouponModal = {setCouponModal}
          title = {isVoucher ? translateWithI18Next(REMOVE_VOUCHER) : translateWithI18Next(REMOVE_GIFT_CARD)}
          giftCardErrFirstMsg={translateWithI18Next(GIFT_CARD_ERROR_FIRST_MSG)}
          giftCardOrVoucherErrMsg={isVoucher ? translateWithI18Next(VOUCHER_ERROR_SECOND_MSG) : translateWithI18Next(GIFT_CARD_ERROR_SECOND_MSG)}
          confirmButtonText = {translateWithI18Next(REMOVE)}
        />
      )}
      {cartSummaryErrorMessage({
        totalAmount,
        currencySymbol,
        currencyConversionFactor,
        maxOrderAmount,
        minOrderAmount,
        checkoutButtonDisabled,
        isCateringDispositionVal: isCateringDisposition(dispositionData?.type),
        enableAddGiftCardOrVoucher,
        isValidPaymentDiscount,
      })}
      {showCateringAlert ? (
        <CartAlertFormInsideModel
          handleClose={handleClose}
          classNames='clear-cart-modal item-unavailable cart-checkout-alert'
          CartAlertForm={
            <CartAlertForm
              title={titleTemplate}
              contentMsg={translateWithI18Next(CART_CATERING_CONTENT_TEXT)}
              imageSrc={CartError}
              altText={''}
              confirmButtonText={translateWithI18Next(CONSTANTS.feedbackSuccessOk)}
              confirmHandler={handleClose}
            />
          }
        />
      ) : null}
      {OrderScheduleModal ? (
        <CartAlertFormInsideModel
          handleClose={modalCloseHandler}
          classNames='clear-cart-modal item-unavailable cart-checkout-alert schedule-time-lapsed'
          CartAlertForm={
            <CartAlertForm
              title={getAlertModalTitle(
                enableClickCollectScheduleOrderFlag,
                isStoreTemproryClosedFlag,
                scheduleTimeCheck,
              )}
              contentMsg={translateWithI18Next(ORDER_TIME_PASSED_MSG)}
              imageSrc={Timeout_Red}
              altText={''}
              confirmButtonText={translateWithI18Next(RESCHEDULE_ORDER_TIME_BUTTON)}
              confirmHandler={event =>
                onRescheduleOrderHandler(event, setOrderScheduleModal, userOrderStateDispatch, storeInfo)
              }
              cancelHandler={showIsAsapFlag(storeStatus, orderASAP, storesWithStatus)}
              cancelButtonText={translateWithI18Next(ORDER_ASAP)}
            />
          }
        />
      ) : null}
    </div>
  );
};

export default CartSummaryCard;
